import { useEffect, useState } from "react";

export function useDebounce<T>(value: T, delay = 250): T {
    const[debounced, setDebounced] = useState<T>(value);
    useEffect(() => {
        const h = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(h);
    }, [value,delay]);
    return debounced;
}